import * as React from "react";
const SvgFiRrBowArrow = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-bow-arrow_svg__a)">
      <path
        fill="#062147"
        d="M21 0h-3a1 1 0 1 0 0 2h2.586l-3.225 3.225A13.4 13.4 0 0 0 1.418 4.141a3.1 3.1 0 0 0-1.4 2.294A3.14 3.14 0 0 0 .925 9l6.33 6.33L4.585 18H1a1 1 0 0 0 0 2h1.586l-1.293 1.293a1 1 0 1 0 1.414 1.414L4 21.414V23a1 1 0 1 0 2 0v-3.586l2.668-2.668L15 23.075a3.14 3.14 0 0 0 2.565.907 3.1 3.1 0 0 0 2.294-1.4 13.4 13.4 0 0 0-1.084-15.943L22 3.414V6a1 1 0 1 0 2 0V3a3 3 0 0 0-3-3M2.34 7.588a1.16 1.16 0 0 1-.178-1.414 1.1 1.1 0 0 1 .344-.356 11.26 11.26 0 0 1 6.14-1.807c2.666-.004 5.25.927 7.3 2.633l-7.278 7.274zm15.842 13.9a1.11 1.11 0 0 1-.826.5 1.16 1.16 0 0 1-.944-.333l-6.33-6.329 7.275-7.274a11.39 11.39 0 0 1 .825 13.441z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-bow-arrow_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBowArrow;
